import { DEFAULT_ACCENT_NAME, DEFAULT_TEXT_ON_ACCENT_NAME } from '@typedream/core';
import { TRenderElementProps } from '@udecode/plate-core';
import { ComponentType } from 'react';
import { createTElementPluginFactory } from '../../plate';
import { ELEMENT_BUTTON, ELEMENT_LINK } from '../../pluginKeys';
import { withDropTarget } from '../../plugins/dnd';
import { ButtonElementEditor } from './components/ButtonElement';

export const createButtonPlugin = createTElementPluginFactory({
  key: ELEMENT_BUTTON,
  component: withDropTarget(ButtonElementEditor as ComponentType<TRenderElementProps>),
  options: {
    isDreamBlock: true,
    isSelectable: true,
    isResizable: true,
    isDraggable: true,
    isDroppable: true,
    meta: {
      img: '/canvas/images/button.png',
      title: 'Button',
      subtitle: 'Add a button that links somewhere',
    },
    format: {
      formatType: 'block',
      focusableWhenEmpty: true,
      validProperties: [
        'buttonType',
        'color',
        'background',
        'align',
        'icon',
        'width',
        'width_max',
        'mobile_hide',
        'desktop_hide',
        'url',
        'internal_link',
        'page_id',
        'open_in_new_tab',
        'animation',
        'connect_data',
        'margin',
        'border_radius',
        'box_shadow',
      ],
      validChildrenTypes: [ELEMENT_LINK],
      setBlockProperties: () => ({
        background: DEFAULT_ACCENT_NAME,
        color: DEFAULT_TEXT_ON_ACCENT_NAME,
      }),
      text: 'Button',
    },
  },
});
